import { useState } from "react"
import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { TranslationKey } from "../../../../../../localization/translations"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import { ProductCardTitle } from "../../../../../../../shared/components/createOrder/components/shop/product/ProductCardTitle"

type StyleProps = Readonly<{ noGrow: boolean }>

const useStyles = makeStyles<StyleProps>()((theme, { noGrow }) => ({
    root: {
        flex: noGrow ? "0 1 auto" : 1,
        minWidth: 0,
    },
    dialogName: {
        padding: "1.5rem",
        color: theme.palette.tailwind.slate[800],
    },
}))

type Props = Readonly<{
    name: string
    dialogTitleId: TranslationKey
    titleClassName?: string
    noGrow?: boolean
}>

export function ProductionClampedName({ name, dialogTitleId, titleClassName, noGrow = false }: Props) {
    const { classes } = useStyles({ noGrow })
    const { l10n } = useAppLocalization()

    const [isDialogOpen, setIsDialogOpen] = useState(false)

    return (
        <Box className={classes.root}>
            <ProductCardTitle
                name={name}
                maxLines={1}
                infoOnlyWhenTruncated
                titleClassName={titleClassName}
                onInfoClick={() => setIsDialogOpen(true)}
            />

            <StandardDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                disableMobileFullScreen
                dialogTitle={l10n.getString(dialogTitleId)}
            >
                <Typography variant="body1" className={classes.dialogName}>
                    {name}
                </Typography>
            </StandardDialog>
        </Box>
    )
}
